"use strict";
export var ContextMenuTriggerMode = /* @__PURE__ */ ((ContextMenuTriggerMode2) => {
  ContextMenuTriggerMode2["Primary"] = "primary";
  ContextMenuTriggerMode2["Secondary"] = "secondary";
  return ContextMenuTriggerMode2;
})(ContextMenuTriggerMode || {});
